<template>
    <section class="jsk-block pt-0">
      <div class="container">
          <div class="row">
              <div class="col-12 text-center">
                <h2>{{ $t("teachersPage.formTitle") }}</h2>
              </div>
              <div class="col-12 col-lg-8 offset-lg-2 px-lg-0 pt-5">
                
                <form
                    id="teachersForm"
                    @submit="checkForm"
                    >
                    <div class="row">
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="name">{{ $t('teachersPage.labelName') }}</label>
                            <input
                                id="name"
                                v-model="nameT"
                                type="text"
                                name="nameT"
                                class="form-control"
                            >
                        </div>
                        <div class="col-12 col-lg-6 col-sm-12 form-group">
                            <label for="email">{{ $t('teachersPage.labelEmail') }}</label>
                            <input
                                id="email"
                                v-model="emailT"
                                type="text"
                                name="emailT"
                                class="form-control"
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12 form-group">
                            <label for="school">{{ $t('teachersPage.labelSchool') }}</label>
                            <input
                                id="school"
                                v-model="schoolT"
                                type="text"
                                name="schoolT"
                                class="form-control"
                                >
                        </div>
                    </div>    
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12 form-group">
                            <label for="curricula">{{ $t('teachersPage.labelCurricula') }}</label>
                            <select
                                id="curricula"
                                v-model="curriculaT"
                                name="curriculaT"
                                class="form-control"
                            >
                                <option disabled value="placeholder">{{ $t('teachersPage.optionDisabled') }}</option>
                                <option value="Hello-World">{{ $t('helloWorldPage.title') }}</option>
                                <option value="Hello-JS">{{ $t('helloJsPage.title') }}</option>
                                <option value="ambele-curricule">{{ $t('teachersPage.bothOption') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12 form-group text-center mt-4">
                            <input
                                type="submit"
                                :value="$t('teachersPage.downloadBtn')"
                                class="btn btn-xl btn-secondary btn-round text-uppercase"
                            >
                            <p v-if="errors.length" class="mt-4">
                                <b>{{ $t('privateSchoolsPage.errorText') }}</b>
                                <ul class="list-unstyled mt-3">
                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                </ul>
                            </p>
                             <p class="mt-4">{{ returnMessage }}</p>
                        </div>
                        
                    </div> 
                </form>
            </div>
          </div>
      </div>
</section>
</template>

<script>
export default {
  name: "teachersForm",
  data() {
      return {
        errors: [],
        nameT: '',
        emailT: '',
        schoolT: '',
        curriculaT: "placeholder",
        returnMessage: ''
    }
  },
  methods:{
    checkForm: function (e) {
      e.preventDefault();

      this.errors = [];

      if (!this.nameT) {
        this.errors.push(this.$t('teachersPage.nameError'));
      }
      if (!this.emailT) {
        this.errors.push(this.$t('teachersPage.emailError'));
      }
       if (!this.schoolT) {
        this.errors.push(this.$t('teachersPage.schoolError'));
      }
      if (!this.curriculaT || this.curriculaT == "placeholder") {
        this.errors.push(this.$t('teachersPage.courseError'));
      }

      this.axios.post('https://www.jskids.ro/php/teachersCurriculaForm.php', new FormData(e.target), {headers: { 'content-type': 'application/form-data' }})
        .then(function (response) {
            this.returnMessage = response.data;
            if (this.returnMessage == "OK") {
                this.returnMessage = this.$t('teachersPage.sucessMessage');
            }
        }.bind(this))
        .catch(function (error) {
            this.returnMessage = error;
            if (this.returnMessage) {
                this.returnMessage = this.$t('general.errorMessage');
            }
        }.bind(this));
    }
  }
};
</script>